var _style, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B0B0B0;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1306.000000, -24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1318,26c-5.5,0-10,4.5-10,10s4.5,10,10,10s10-4.5,10-10S1323.5,26,1318,26z M1318,30.6 c1.8,0,3.3,1.5,3.3,3.4s-1.5,3.4-3.3,3.4s-3.3-1.5-3.3-3.4S1316.2,30.6,1318,30.6z M1318,44.9c-2.3,0-4.5-0.9-6.2-2.5 c1.7-2.3,3.9-3.5,6.2-3.5s4.5,1.2,6.2,3.5C1322.5,44,1320.3,44.9,1318,44.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissing);
export default __webpack_public_path__ + "static/media/Missing.f4d74200a3e3a2889a04412fbfe2171a.svg";
export { ForwardRef as ReactComponent };